import {useLoaderData, useParams} from "react-router-dom";
import UserAccount from "../../../../Components/UserAccount";
import {ReactElement, useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import "../../../../Assets/Css/Pages/User/Invoice/invoice.css";
import "../../../../Assets/Css/Pages/User/WZ/Details/details.css";
import {UserIsNotLogged} from "../../../../Components/UserUIMessages";
import {UserContext} from "../../../../Contexts/UserContext";
import {Throbber} from "../../../../Components/Throbber";
import {DocumentActions} from "./DocumentActions";
import {DocumentInfo} from "./DocumentInfo";
import {ItemsTable} from "./ItemsTable";
import {WZDetails} from "./types";
import {useWZDocumentActions} from "./useWZDocumentActions";

export default function WZ(): ReactElement {
    const wz = useLoaderData() as WZDetails | null;
    const {id} = useParams();
    const {t} = useTranslation();
    const userContext = useContext(UserContext);
    const [cartThrobber, setCartThrobber] = useState(false);
    const wzId = wz?.id ?? Number(id);
    const {downloading, downloadError, download} = useWZDocumentActions(wzId);

    if (!userContext?.user) {
        return <UserIsNotLogged />;
    }

    if (wz === null) {
        return <></>;
    }

    const breadcrumb = [
        {name: t('user-page.wzs.title'), path: '/user/wz'},
        {name: wz.wzNumber, path: null},
    ];

    return (
        <UserAccount title={t('user-page.wz.title') + ': ' + wz.wzNumber} className="my-wz" breadcrumb={breadcrumb}>
            <div className="top-data wz-top-data">
                <DocumentInfo wz={wz} />
                <DocumentActions
                    id={wzId}
                    setCartThrobber={setCartThrobber}
                    downloading={downloading}
                    downloadError={downloadError}
                    download={download}
                />
            </div>

            <Throbber visible={cartThrobber || downloading !== null} />

            <ItemsTable items={wz.wzItem} />
        </UserAccount>
    );
}
